import { auditTarget } from "../../api/mcp";
import type { AuditProduct } from "../../hooks/useAuditFeed";

/** Where a target opens in the console, when a page exists for it. */
export function targetLink(
  e: { domain: string; target: unknown },
  product: AuditProduct,
): string | null {
  const target = auditTarget(e.target);
  if (!target) return null;
  if (e.domain === "tenant") return `/tenants/${encodeURIComponent(target)}`;
  if (product === "labeeb" && e.domain === "settings" && target.startsWith("tenant/")) {
    const id = target.split("/")[1];
    if (id) return `/tenants/${encodeURIComponent(id)}`;
  }
  if (product === "labeeb" && e.domain === "quota" && target.startsWith("tenant/")) {
    const id = target.split("/")[1];
    if (id) return `/tenants/${encodeURIComponent(id)}`;
  }
  // The paused-tools list has one target (`paused_tools`) and one page: the
  // Paused tools panel on Policy → Settings.
  if (product === "mcp" && e.domain === "availability") return "/policy/settings";
  if (product === "mcp" && e.domain === "quota") {
    return `/policy/caps/${encodeURIComponent(target.split("/")[0] ?? "")}`;
  }
  return null;
}
